import { createAction } from '@reduxjs/toolkit';
export const saveCompanyTasksSagaAction = createAction('home/saveCompanyTasksSagaAction');
export const saveHomeResponseSagaAction = createAction('home/saveHomeResponseSagaAction');
